import { useState } from "react";
import PageLayout from "../../components/layouts/PageLayout";
import CustomNavbar from "../../components/common/CustomNavbar";
import LiveChatContacts from "./LiveChatContacts";
import LiveChatWindow from "./LiveChatWindow";
import { useLocation } from "react-router-dom";

export default function LiveChat() {
     const location = useLocation();
    const [selectedPhone, setSelectedPhone] = useState<string>(
        (location.state as any)?.phone || ""
    );

    return (
        <PageLayout
            customNavbar={
                <CustomNavbar>
                    <div className="flex gap-3 items-center w-max">
                        <span className="font-bold text-lg uppercase">
                            LIVE CHAT
                        </span>
                    </div>
                </CustomNavbar>
            }
        >
            {/* WhatsApp Web style shell */}
            <div className="w-full h-[calc(100vh-132px)] min-h-[520px] flex rounded-2xl overflow-hidden bg-white shadow-[0_6px_24px_-8px_rgba(11,20,26,0.18),0_1px_3px_rgba(11,20,26,0.08)] border border-[#e9edef]">
                <LiveChatContacts
                    selectedPhone={selectedPhone}
                    onSelectContact={setSelectedPhone}
                />

                <LiveChatWindow selectedPhone={selectedPhone} />
            </div>
        </PageLayout>
    );
}